/**
 * @voltxampere/schema — Node
 *
 * Per SPECS §1.2. A Node is a connection point with a position and a
 * reference to its Net. Ground status lives on the Net, not the Node.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
import { PointSchema } from "./_primitives.js";
export const NodeSchema = z
    .object({
    id: z.string(),
    position: PointSchema,
    netId: z.string(),
})
    .strict();
//# sourceMappingURL=node.js.map